import { useQueryCertificateAll } from "@/api/certificate/certificate";
import { CertificateStatus } from "@/api/enums/CertificateStatus";
import { useMemo } from "react";

export const useCandidateCertificates = (candidateId?: number) => {
  const {
    data: certificates,
    isPending,
    isError,
  } = useQueryCertificateAll(candidateId);

  // undefined until there is a list to judge a certificate against
  const selectableCertificates = useMemo(() => {
    if (!certificates) return undefined;

    const now = new Date();

    return certificates.filter(
      (certificate) =>
        (certificate.status as CertificateStatus) ===
          CertificateStatus.VALIDATED &&
        new Date(certificate.expirationDate) >= now,
    );
  }, [certificates]);

  return { certificates, selectableCertificates, isPending, isError };
};
